import { isNil, omit } from "lodash-es";

/**
 * The part of `fixedFilters` that actually locks a filter. A key only counts
 * as fixed when its value is set — callers pass e.g. `templateTypeIds: null`
 * when there is no type constraint, and the form keeps such a field editable
 * (MEIS-10975).
 */
export const getLockedFilters = <T extends object>(
  fixedFilters: T | undefined
): Partial<T> => {
  const locked: Partial<T> = {};
  if (!fixedFilters) return locked;
  for (const key of Object.keys(fixedFilters) as Array<keyof T>) {
    if (!isNil(fixedFilters[key])) locked[key] = fixedFilters[key];
  }
  return locked;
};

/**
 * Drops the keys locked by `fixedFilters` from filter form values, so fixed
 * values mirrored into the form are never written back into the editable
 * filters (where they would resurface as chips after "Clear all").
 */
export const omitFixedFilters = <T extends object>(
  values: T,
  fixedFilters: object | undefined
): Partial<T> => omit(values, Object.keys(getLockedFilters(fixedFilters)));
